var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('span',[_vm._v("\n    © "+_vm._s(new Date().getFullYear())+"\n    "),_c('a',{attrs:{"id":"footer-link-nanome","href":"https://nanome.ai/"}},[_vm._v("Nanome")])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ml-3"},[_c('a',{attrs:{"href":"https://docs.nanome.ai","target":"_blank"}},[_vm._v("Docs")])])
}]

export { render, staticRenderFns }